<nav class="navbar bg-primary header-nav" role="navigation">
  <div class="container">
    <a class="navbar-brand float-start" href="https://azdeq.gov/">
      <img
        class="img-responsive"
        style="max-height: 50px"
        src="https://static.azdeq.gov/mydeq/img/adeq_logo_wht.png"
        alt="myDEQ"
      />
    </a>
    <!--     <div class="float-end d-none d-md-block " id="navbarNavDropdown">
      <ul class="nav justify-content-end">
        <li class="nav-item">
          <div id="userNameLabel">
            <p class="mb-0 divider-vertical"> {{headerDetail?.first_name}} {{headerDetail?.last_name}} </p>
          </div>
        </li>

        <li class="nav-item">
          <a class="nav-link"  href="javascript:void(0)" (click)="logoutMe()">
            <u>LOGOUT</u>
          </a>
        </li>
        <li class="nav-item active">
          <a class="nav-link" href="/mydeq/my-stuff">mySTUFF</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/mydeq-settings/home">mySETTINGS</a>
        </li>
      </ul>
    </div> -->
  </div>
</nav>
